import { Container, Title, Text, Button, Stack, Paper, Group, Center } from '@mantine/core'
import { IconRefresh, IconTools } from '@tabler/icons-react'
import { useI18n } from '../hooks/useI18n'

interface MaintenanceErrorFallbackProps {
    error: Error
    resetErrorBoundary: () => void
}

export const MaintenanceErrorFallback: React.FC<MaintenanceErrorFallbackProps> = ({
    error,
    resetErrorBoundary,
}) => {
    const { t } = useI18n()

    return (
        <Container size="sm" py="xl">
            <Paper shadow="md" p="xl" radius="md">
                <Stack align="center" gap="lg">
                    <Center>
                        <IconTools size={64} color="var(--mantine-color-blue-6)" />
                    </Center>

                    <Title order={1} ta="center" c="customGreen">
                        {t('maintenance.title')}
                    </Title>

                    <Title order={3} ta="center" c="dimmed" fw={400}>
                        {t('maintenance.subtitle')}
                    </Title>

                    <Text c="dimmed" ta="center" size="md">
                        {t('maintenance.description')}
                    </Text>

                    <Group gap="md" justify="center">
                        <Button
                            leftSection={<IconRefresh size={16} />}
                            onClick={resetErrorBoundary}
                            variant="light"
                            color="customGreen"
                            size="md"
                        >
                            {t('maintenance.tryAgain')}
                        </Button>

                    </Group>

                    {/* Show error details only in development */}
                    {import.meta.env.DEV && (
                        <Paper p="md" bg="red.0" radius="sm" w="100%">
                            <Text size="xs" ff="monospace" c="red.8">
                                {error.message}
                            </Text>
                        </Paper>
                    )}
                </Stack>
            </Paper>
        </Container>
    )
} 